export function addServiceCodeToHeap() {
	const isServiceCodeUpdated = window.modForm.opts.initialServiceCode && window.modForm.opts.vertical && window.modForm.opts.initialServiceCode !== window.modForm.opts.vertical;
	if ((window.modForm.opts && window.modForm.opts.vertical && !window.modForm.opts.isServiceCodeStampedInHeap) || isServiceCodeUpdated) {
		window.modForm.opts.initialServiceCode = window.modForm.opts.vertical;
		const properties = {
			'serviceCode': window.modForm.opts.vertical
		};
		window.Modalytics.heap('addEventProperties', properties);
		window.Modalytics.heap('addUserProperties', properties);
		window.modForm.opts.isServiceCodeStampedInHeap = true;
	}
}
